import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import i18n from '@/i18n';

interface MonitorMutingStatusProps {
  status: 'MUTED' | 'NOT_MUTED';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Monitor-Muting-Status',
  props: {
  status: null
},
  setup(__props) {

const props = __props;


const text = _computed(() => i18n.t(`tree_selector.${props.status}`));
const icon = _computed(() => (props.status === 'MUTED' ? 'icon-alert-off' : 'icon-alert'));

return { __sfc: true,props, text, icon, _computed, SEllipsisTooltip, i18n }
}

})